// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__xZIrI","Content":"FAQ_Content__c3mBj","sweep":"FAQ_sweep__v5Bdm"};